import { Box, Grid, Typography } from "@mui/material";
import { STATICS } from "api/api";
import React from "react";
import { getFocus, useGet } from "state/jotai";
import { active_project } from "state/store.global";
import { _project } from "state/store.projects";

// Function to remove duplicates from contactData based on unique properties
const removeDuplicates = (data) => {
  const seen = new Set();
  return data.filter((item) => {
    const identifier = `${item?.Name}|${item?.AddressLine1}|${item?.AddressLine2}|${item?.Phone}|${item?.Email}`;
    return !seen.has(identifier) && seen.add(identifier);
  });
};

function Footer() {
  const { pin, pid } = useGet(active_project);
  const buttonsLabel = getFocus(_project, "buttonsLabel")?.[pin]?.[pid] ?? [];
  const contactData =
    getFocus(_project, "ContactProperties")?.[pin]?.[pid] ?? [];

  // Filter out duplicates
  const uniqueContactData = removeDuplicates(contactData);
  const logoUrl = uniqueContactData?.[0]?.ImageUrl
    ? `${STATICS}${uniqueContactData[0].ImageUrl}`
    : null;
// if (pid == 4 || pid == 5) {
//     return null;
//   }

  return (
    <div>
      <Box
        sx={{
          mt: 5,
          pb: 55,
          pr: { md: 10, xs: 4 },
          pl: { md: 5, xs: 4 },
          py: { md: 0, xs: 2 },
          lineHeight: 1.4,
          position: "relative",
          maxWidth: 756,
          margin: "auto",
        }}
      >
        {/* Footer Heading */}
        <Box
          sx={{
            mb: 2,
            color: clr.primary_text,
            mt: 3,
          }}
        >
          <span className="h3">
            {buttonsLabel?.filter(
              (btn) => btn.UILabelProperty === "SidefodKontaktOverskrift"
            )[0]?.Label || "Kontaktinformation"}
          </span>
        </Box>

        {/* Travbyen Contact Info */}
        <Grid container spacing={3} sx={{ mb: 5 }}>
          <Grid item lg={6} xs={12}>
            <Box sx={{ color: clr.primary_text }}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1rem",
                  lineHeight: 1.6,
                  color: clr.primary_text,
                }}
              >
                {
                  buttonsLabel?.find(
                    (btn) => btn.UILabelProperty === "TravbyenDialog"
                  )?.Label
                }
                <br />
                <strong>
                  {" "}
                  {
                    buttonsLabel?.filter(
                      (btn) => btn?.UILabelProperty === "kontaktOs"
                    )[0]?.Label
                  }:{" "}
                </strong>
                <a
                  href="mailto:kontakt@travbyen.dk"
                  style={{
                    color: clr.primary_text,
                    fontWeight: 700,
                    textDecoration: "none",
                  }}
                >
                  kontakt@travbyen.dk
                </a>
              </Typography>
            </Box>
          </Grid>

          <Grid
            item
            lg={6}
            xs={12}
            sx={{
              textAlign: { lg: "center", xs: "left" },
              display: "flex",
              justifyContent: { xs: "flex-start", lg: "flex-end" },
              alignItems: "center",
               mt: 6 
            }}
          >
            {logoUrl && (
              <Box sx={{ width: 182 }}>
                <Box
                  component="img"
                  src={logoUrl}
                  alt="Travbyen logo"
                  sx={{
                    width: "100%",
                    height: "auto",
                    objectFit: "contain",
                    cursor: "pointer",
                  }}
                />
              </Box>
            )}
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default Footer;
